export const breakpoints = [576, 768, 992, 1200];
export const breakpointsMinHeight = [700];
// eslint-disable-next-line
export const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`);
export const mqMinHeight = `@media (max-height: ${breakpointsMinHeight}px)`;
